import HighlightOffOutlinedIcon from '@mui/icons-material/HighlightOffOutlined';
import { Alert, AlertTitle, Collapse, IconButton } from "@mui/material";
import React from "react";

export const Notice = ({title, children, color = 'info', id, onClose = () => {}}) => {
    const [open, setOpen] = React.useState(true);
    return (
        <Collapse in={open}>
            <Alert id={id} color={color} severity={color} variant="outlined" sx={{ mb: 1 }} action={
                <IconButton
                aria-label="close"
                color="inherit"
                size="small"
                onClick={() => {
                    setOpen(false);
                    onClose()
                }}
                >
                <HighlightOffOutlinedIcon />
                </IconButton>
            }>
                {title && <AlertTitle>{title}</AlertTitle>}
                {children}
            </Alert>
        </Collapse>
    );
}